import * as yup from 'yup';

let serviceTypetValidationForm = yup.object().shape({
    name: yup.string().required("Name is required"),
})

export {
  serviceTypetValidationForm
}